import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// @ts-nocheck
import React from "react";
import { gql, useLazyQuery } from "@apollo/client";
import { makeStyles, AppBar, IconButton, Menu, MenuItem, Toolbar, Link, Tooltip, Grid, useMediaQuery, useTheme, Avatar, Logo, Badge, ListItemText, Divider, ErrorHandling, } from "../mui";
import { useHistory } from "react-router-dom";
import { ContentTypography, getContent } from "../common/content";
import RouteConstants from "../../routes/RouteConstants";
import { AccountCircle, Notifications, Logout, Person2 } from "@mui/icons-material";
import { signOut } from "../../utils/auth/graph_helper";
import { customerType, LandingPath, userSource } from "../../utils/enums";
import constants from "../../utils/constants";
import { UpgradeSubscriptionDialog } from "../common/dialogs";
import { useMsal } from "@azure/msal-react";
const NAVIGATION_HEADER = gql `
  query NavigationHeader($userId: ID!, $organizationId: ID!) {
    user(id: $userId) {
      id
      logoUrl
      source
      avatar {
        id
        url
      }
      notifications {
        id
        label
      }
    }
    organization(id: $organizationId) {
      id
      name
      customerType
      logo {
        id
        url
      }
    }
  }
`;
const useStyles = makeStyles((theme) => ({
    toolbar: {
        backgroundColor: "#202020",
    },
}));
const NavigationHeader = ({ view = "" }) => {
    const { instance, accounts } = useMsal();
    const userId = localStorage.getItem("userId") || null;
    const organizationId = localStorage.getItem("organizationId") || null;
    const classes = useStyles();
    const history = useHistory();
    const theme = useTheme();
    const mdMatches = useMediaQuery(theme.breakpoints.up("md"));
    const [loggedOut, setLoggedOut] = React.useState(false);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [anchorElNotification, setAnchorElNotification] = React.useState(null);
    const [badges, setBadges] = React.useState(0);
    const [getUser, { loading, error, data }] = useLazyQuery(NAVIGATION_HEADER);
    React.useEffect(async () => {
        if (userId === "null" || userId === null || organizationId === "null" || organizationId === null) {
            setLoggedOut(true);
            await signOut();
            return history.push(RouteConstants.Login.path);
        }
        else {
            getUser({
                variables: {
                    userId,
                    organizationId,
                },
            });
            setLoggedOut(false);
        }
    }, [userId, organizationId]);
    const handleMicrosoftLogout = () => {
        instance.logoutPopup();
    };
    if (loading)
        return null;
    if (error)
        return _jsx(ErrorHandling, { error: error });
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };
    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };
    const handleOpenNotificationMenu = (event) => {
        setAnchorElNotification(event.currentTarget);
    };
    const handleCloseNotificationMenu = () => {
        setBadges(0);
        setAnchorElNotification(null);
    };
    return (_jsx(AppBar, { position: "static", children: _jsx(Toolbar, { className: classes.toolbar, children: _jsxs(Grid, { container: true, justifyContent: !view ? "space-between" : "flex-end", alignItems: "center", children: [!view && (_jsx(Grid, { item: true, children: _jsx(Logo, { loggedIn: !loggedOut, organization: data?.organization }) })), loggedOut && view === LandingPath.login && (_jsxs(_Fragment, { children: [_jsx(Grid, { item: true, children: _jsx(ContentTypography, { color: "secondary", field: mdMatches ? "signUpPreMessage" : "" }) }), _jsx(Grid, { item: true, children: _jsx(Tooltip, { title: getContent("signUpLabel"), children: _jsxs(Link, { color: "primary", display: "inline", onClick: () => history.push(`${RouteConstants.Login.path}?view=${LandingPath.signup}`), underline: "always", sx: { cursor: "pointer", textDecoration: "none" }, children: ["\u00A0", getContent("signUpPostMessage")] }) }) })] })), !loggedOut && !view && (_jsx(Grid, { item: true, children: _jsxs(Grid, { container: true, spacing: 1, children: [data?.organization?.customerType === customerType.Trial && (_jsx(Grid, { item: true, children: _jsx(UpgradeSubscriptionDialog, {}) })), _jsxs(Grid, { item: true, children: [_jsx(Tooltip, { title: getContent("notificationsLabel"), children: _jsx(IconButton, { onClick: handleOpenNotificationMenu, children: _jsx(Badge, { badgeContent: badges, color: "primary", overlap: "rectangular", size: "large", children: _jsx(Notifications, { fontSize: "inherit", color: "secondary" }) }) }) }), _jsx(Menu, { anchorEl: anchorElNotification, anchorOrigin: { vertical: "bottom", horizontal: "center" }, transformOrigin: { vertical: "top", horizontal: "center" }, keepMounted: true, open: Boolean(anchorElNotification), onClose: handleCloseNotificationMenu, children: data?.user?.notifications.map((notification, index) => (_jsxs("div", { children: [_jsx(MenuItem, { children: _jsx(ListItemText, { children: notification.label }) }), _jsx(Divider, { flexItem: true })] }, index))) })] }), _jsxs(Grid, { item: true, children: [_jsx(Tooltip, { title: getContent("openSettingsLabel"), children: _jsx(IconButton, { onClick: handleOpenUserMenu, children: data?.user ? (_jsx(Avatar, { alt: "avatar", src: data?.user?.logoUrl || data?.user?.avatar?.url, sx: { width: 28, height: 28 } })) : (_jsx(AccountCircle, { fontSize: "medium", color: "secondary" })) }) }), _jsxs(Menu, { anchorEl: anchorElUser, anchorOrigin: { vertical: "bottom", horizontal: "center" }, transformOrigin: { vertical: "top", horizontal: "center" }, keepMounted: true, open: Boolean(anchorElUser), onClose: handleCloseUserMenu, children: [_jsxs(MenuItem, { onClick: () => history.push(`${RouteConstants.Settings.path}?view=${constants.SETTING_TABS.Personal}`), children: [_jsx(Person2, { fontSize: "small" }), _jsx(ContentTypography, { variant: "button", color: "secondary", fontWeight: "bold", sx: { textTransform: "none" }, field: "profileLabel" })] }), _jsxs(MenuItem, { onClick: async () => {
                                                        if (data?.user?.source === userSource.microsoft) {
                                                            await handleMicrosoftLogout();
                                                        }
                                                        await signOut();
                                                        setLoggedOut(true);
                                                        history.push(RouteConstants.Login.path);
                                                    }, children: [_jsx(Logout, { fontSize: "small" }), _jsx(ContentTypography, { variant: "button", color: "secondary", fontWeight: "bold", sx: { textTransform: "none" }, field: "logoutLabel" })] })] })] })] }) }))] }) }) }));
};
export default NavigationHeader;
